import React from 'react';
import { inject, observer } from 'mobx-react';

import { Label } from 'sdc-i18n-react';
import { fieldValue } from 'sdc-data-models';

export var BooleanView = inject('editingStore')(observer(function (_ref) {
  var editingStore = _ref.editingStore,
      field = _ref.field;
  return React.createElement(Label, { value: 'boolean.' + fieldValue(editingStore._sending, field.key) });
}));